// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__2LwYI","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__17R4y"};